(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('reporting-area-activity', {
            parent: 'entity',
            url: '/reporting-area-activity',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.reportingAreaActivity.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-area-activity/reporting-area-activity.html',
                    controller: 'ReportingAreaActivityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reportingAreaActivity');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
